export const EXPERIMENTS = {
  ENABLE_MULTILINE_ADDRESS: 'specs.forms.MultilineAddressInTemplates',
  SHOW_DEMO_FORM: 'specs.forms.ShowDemoForm',
  ENABLE_PRESET_TAB: 'specs.forms.EnablePresetTab',
  TEMPLATE_DESIGNER: 'specs.forms.TemplateDesigner',
  REMOVE_BOOKINGS_DEPENDENCY: 'specs.services.RemoveBookingsDependency',
  BIF_SILENT_INSTALL: 'bifOnMeetingsSilentInstall',
  BOXLESS_TEXT_STYLES: 'specs.forms.BoxlessTextStyles',
  ENABLE_HEADING_LEVELS: 'specs.forms.EnableHeadingLevels',
  NEW_BUTTONS_DESIGN_PANEL: 'newButtonsDesignPanel',
  STUDIO2_THUMBNAILS: 'formsStudio2Thumbnails',
  NEW_MANAGE_TAB_SETTINGS: 'newManageTabSettings',
};
